// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/password-input.js
import BaseComponent from "./base_component"

export default class PasswordInput extends BaseComponent {
  static componentName = "password-input"

  constructor(element, config = {}) {
    super(element, config)
    this.input = element
      .closest(".form-password")
      ?.querySelector('input[type="password"], input[type="text"], input[data-coreui-password]')
    if (this.input) element.setAttribute("aria-pressed", this.input.type === "text")
  }

  toggle() {
    if (!this.input) return
    const visible = this.input.type === "password"
    this.input.type = visible ? "text" : "password"
    this.element.setAttribute("aria-pressed", visible)
  }
}
